import { useQuery } from "urql";

import { graphql } from "@/__graphql__";
import { PastAndFutureAppointmentsArgs } from "@/__graphql__/graphql";

export function useAppointments(params: PastAndFutureAppointmentsArgs) {
  return useQuery({
    query: AppointmentsQuery,
    variables: { params },
  });
}

const AppointmentsQuery = graphql(`
  query PastAndFutureAppointments__PastAndFutureAppointments__AppointmentsQuery($params: PastAndFutureAppointmentsArgs!) {
    pastAndFutureAppointments(params: $params) {
      totalCount
      edges {
        appointmentId
        worksheetId
        appointmentType {
          id
          publicName
        }
        location {
          id
          name
          relation {
            id
            afasCode
            name
          }
          address {
            street
            postalCode
            city
            country
          }
        }
        employees {
          username
        }
        startTime
        endTime
        status
        files {
          id
          name
        }
      }
    }
  }
`);
